import React from 'react'
import FlexyTrasladoForm from '../../components/integracion-flexy/traslados/FlexyTrasladoForm'

const FlexyTrasladoCreatePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold">Crear transferencia Flexy</h2>
          <p className="mt-1 text-sm text-gray-500">
            Registra una transferencia entre almacenes WMS hacia Flexy
          </p>
        </div>

        <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
          <FlexyTrasladoForm />
        </div>
      </div>
    </div>
  )
}

export default FlexyTrasladoCreatePage